import { render } from "./DoctorList.vue?vue&type=template&id=386e9b9e"
import script from "./DoctorList.vue?vue&type=script&lang=js"
export * from "./DoctorList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__